import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>นโยบายความเป็นส่วนตัว</h1>
          <p>ความมุ่งมั่นของเราในการปกป้องความเป็นส่วนตัวของคุณ</p>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="section privacy-content">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="privacy-card">
                <h2>นโยบายความเป็นส่วนตัวของ 707 M CO., LTD.</h2>
                <p className="last-updated">ปรับปรุงล่าสุด: {new Date().toLocaleDateString()}</p>
                
                <div className="privacy-section">
                  <h3>1. บทนำ</h3>
                  <p>707 M CO., LTD. ให้ความสำคัญกับการปกป้องความเป็นส่วนตัวของคุณ นโยบายความเป็นส่วนตัวฉบับนี้อธิบายถึงวิธีที่เราเก็บรวบรวม ใช้ เปิดเผย และปกป้องข้อมูลของคุณเมื่อคุณเยี่ยมชมเว็บไซต์หรือใช้บริการของเรา</p>
                </div>
                
                <div className="privacy-section">
                  <h3>2. ข้อมูลที่เราเก็บรวบรวม</h3>
                  <p>เราอาจเก็บรวบรวมข้อมูลเกี่ยวกับคุณได้หลายวิธี ข้อมูลที่เราอาจเก็บจากการใช้งานเว็บไซต์ประกอบด้วย:</p>
                  <ul>
                    <li><strong>ข้อมูลส่วนบุคคล:</strong> ชื่อ ที่อยู่อีเมล หมายเลขโทรศัพท์ และข้อมูลการติดต่ออื่นๆ ที่คุณให้ไว้</li>
                    <li><strong>ข้อมูลการใช้งาน:</strong> ข้อมูลเกี่ยวกับวิธีการเข้าถึงและการใช้งานเว็บไซต์</li>
                    <li><strong>คุกกี้และข้อมูลการติดตาม:</strong> เราใช้คุกกี้และเทคโนโลยีการติดตามที่คล้ายกันเพื่อดูพฤติกรรมการใช้งานบริการของเรา</li>
                  </ul>
                </div>
                
                <div className="privacy-section">
                  <h3>3. วิธีที่เราใช้ข้อมูลของคุณ</h3>
                  <p>707 M CO., LTD. ใช้ข้อมูลที่เก็บรวบรวมเพื่อวัตถุประสงค์ต่างๆ ดังนี้:</p>
                  <ul>
                    <li>เพื่อให้บริการและดูแลรักษาบริการของเรา</li>
                    <li>เพื่อแจ้งให้คุณทราบเกี่ยวกับการเปลี่ยนแปลงของบริการ</li>
                    <li>เพื่อให้การสนับสนุนลูกค้า</li>
                    <li>เพื่อรวบรวมการวิเคราะห์หรือข้อมูลที่มีประโยชน์ในการพัฒนาบริการของเรา</li>
                    <li>เพื่อตรวจสอบการใช้งานบริการของเรา</li>
                    <li>เพื่อตรวจจับ ป้องกัน และแก้ไขปัญหาด้านเทคนิค</li>
                  </ul>
                </div>
                
                <div className="privacy-section">
                  <h3>4. การเปิดเผยข้อมูล</h3>
                  <p>เราไม่ขาย แลกเปลี่ยน หรือโอนข้อมูลส่วนบุคคลของคุณให้แก่บุคคลภายนอกโดยไม่ได้รับความยินยอม เว้นแต่ตามที่ระบุไว้ในนโยบายฉบับนี้</p>
                  <p>เราอาจแบ่งปันข้อมูลของคุณกับ:</p>
                  <ul>
                    <li><strong>ผู้ให้บริการ:</strong> เราอาจจ้างบริษัทภายนอกเพื่อช่วยให้บริการของเรา</li>
                    <li><strong>ตามกฎหมาย:</strong> เราอาจเปิดเผยข้อมูลของคุณหากกฎหมายกำหนด</li>
                  </ul>
                </div>
                
                <div className="privacy-section">
                  <h3>5. ความปลอดภัยของข้อมูล</h3>
                  <p>ความปลอดภัยของข้อมูลของคุณเป็นสิ่งสำคัญสำหรับเรา เราดำเนินมาตรการรักษาความปลอดภัยที่เหมาะสมเพื่อปกป้องข้อมูลส่วนบุคคลของคุณจากการเข้าถึง แก้ไข เปิดเผย หรือทำลายโดยไม่ได้รับอนุญาต</p>
                </div>
                
                <div className="privacy-section">
                  <h3>6. สิทธิของคุณเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล</h3>
                  <p>คุณมีสิทธิด้านการคุ้มครองข้อมูลส่วนบุคคล เรามุ่งมั่นที่จะดำเนินการตามสมควรเพื่อให้คุณสามารถแก้ไข ปรับปรุง ลบ หรือจำกัดการใช้ข้อมูลส่วนบุคคลของคุณได้</p>
                  <ul>
                    <li><strong>สิทธิในการเข้าถึง:</strong> คุณมีสิทธิขอรับสำเนาข้อมูลส่วนบุคคลของคุณ</li>
                    <li><strong>สิทธิในการแก้ไข:</strong> คุณมีสิทธิขอให้เราปรับปรุงข้อมูลที่ไม่ถูกต้อง</li>
                    <li><strong>สิทธิในการลบ:</strong> คุณมีสิทธิขอให้เราลบข้อมูลส่วนบุคคลของคุณ</li>
                    <li><strong>สิทธิในการจำกัด:</strong> คุณมีสิทธิขอให้เราจำกัดการประมวลผลข้อมูลส่วนบุคคลของคุณ</li>
                  </ul>
                </div>
                
                <div className="privacy-section">
                  <h3>7. คุกกี้</h3>
                  <p>เราใช้คุกกี้และเทคโนโลยีการติดตามที่คล้ายกันเพื่อติดตามการใช้งานบริการและจัดเก็บข้อมูลบางอย่าง คุณสามารถตั้งค่าเบราว์เซอร์ให้ปฏิเสธคุกกี้ทั้งหมดหรือแจ้งเตือนเมื่อมีการส่งคุกกี้ได้</p>
                </div>
                
                <div className="privacy-section">
                  <h3>8. ความเป็นส่วนตัวของเด็กและเยาวชน</h3>
                  <p>บริการของเราไม่ได้มุ่งเน้นไปที่บุคคลที่มีอายุต่ำกว่า 18 ปี และเราไม่ได้ตั้งใจเก็บรวบรวมข้อมูลส่วนบุคคลที่สามารถระบุตัวตนได้จากบุคคลที่มีอายุต่ำกว่า 18 ปี</p>
                </div>
                
                <div className="privacy-section">
                  <h3>9. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวฉบับนี้</h3>
                  <p>เราอาจปรับปรุงนโยบายความเป็นส่วนตัวเป็นครั้งคราว เราจะแจ้งให้คุณทราบถึงการเปลี่ยนแปลงโดยเผยแพร่นโยบายฉบับใหม่บนหน้านี้และปรับปรุงวันที่ “ปรับปรุงล่าสุด”</p>
                </div>
                
                <div className="privacy-section">
                  <h3>10. ติดต่อเรา</h3>
                  <p>หากคุณมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้ โปรดติดต่อเราได้ที่:</p>
                  <ul>
                    <li>ทางอีเมล: info@707m.co.th</li>
                    <li>ทางโทรศัพท์: +66 2 234 5678</li>
                    <li>ทางไปรษณีย์: 968 อาคารอื้อจือเหลียง ชั้นที่ 5 ถนนพระรามที่ 4 แขวงสีลม เขตบางรัก กรุงเทพมหานคร 10500</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
